<template lang="html">
  <div class="find" ref="find">
    <!-- <van-popup v-model="pdfShow"> -->
      <!-- <div id="pdf"></div> -->
      <!-- <pdf :key="i" class="pdf" :page="i" :src="pdfUrl1" v-for="i in numPages"></pdf> -->
    <!-- </van-popup> -->
    <!-- <div @click="pdfShow = !pdfShow">pdf
    </div> -->
    <!-- <h3>星圈</h3> -->
    <transition name="bounce">
      <div v-show="downRefresh" class="downLoading">{{downLabel}}</div>
    </transition>
    <Rotation v-if="getCenterAuth.rotation" selfStyle="margin-left: auto;margin-right: auto;width: 91.47%;margin-top: 16px;"/>
    <div class="recommend">
      <div class="recommend_top">
        <img src="./topic/images/topic-advise.png">
      </div>
      <div class="recommend_dynamic_list">
        <div class="recommend_list" v-for="(item,index) of HotTopicList" :key="index">
            <div class="recommend_list_detail" v-for="elm of item" :key="elm.id">
                <div class="recommend_box">
                    <div class="recommend_dynamic_content">
                        <div class="recommend_dynamic_content_top">
                            <img v-if="elm.type === 1" src="./topic/images/topic-tag.png">
                            <img v-else src="./topic/images/topic-hot.png">
                            <div @click = 'goTopicDetails(elm)'>{{elm.name}}</div>
                        </div>
                        <div @click = 'goTopicDetails(elm)' class="recommend_dynamic_content_bottom">{{ elm.desc }}</div>
                    </div>
                    <div @click = 'goTopicDetails(elm)' class="goCreate" :class="elm.type===1 ? '':'CreateActive'">
                        {{ elm.type===1 ? '去发帖':'去报名' }}
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    <!--2024-2-22 新增ESG 快速入口 -->
    <div class="esg-wrap" v-if="has_esg_entry">
        <van-swipe class="my-swipe"  :show-indicators="false" >
            <van-swipe-item @click = 'onRoute'>
                <van-image
                width="100%"
                :src="esgUrl"
                />
            </van-swipe-item>
        </van-swipe>
    </div>

    <!-- 问卷 start -->
    <div class='vote' v-if='!has_esg_entry && voteList.length > 0'>
      <div class='vote_icon'>
          <img src='../../assets/images/questionnaire/text.png'>
      </div>
      <div class='vote_content'>
            <van-notice-bar :scrollable="false"  class="vote_swipe">
              <van-swipe
                vertical
                :autoplay="3000"
                :show-indicators="false"
                class="vote_swipe_content"
              >
                <van-swipe-item v-for="item in voteList" class='btn' @click = 'goVoteDetail(item.questionnaire_id)' :key="item.questionnaire_id">{{item.title}}</van-swipe-item>
              </van-swipe>
            </van-notice-bar>
            <div class='vote_detail'>
              <img src='../../assets/images/questionnaire/more.png'>
            </div>
      </div>
    </div>
    <!-- 问卷 END -->
    <div  ref="scroll" class="panel-box hot" v-if="getCenterAuth.heatedDiscussion">
      <HeatedDiscussion2 selfStyle="padding: 0px !important;">
        <div class="panel-box-header" slot="name">
          <span class="live-box-header-desc">热门动态</span>
          <button class="query-all" @click="goDynamic">查看全部</button>
        </div>
      </HeatedDiscussion2>
    </div>
    <!-- <div class="panel-box" v-if="getCenterAuth.curriculumn && lives.length" >
      <div class="panel-box-header">
        <span class="live-box-header-desc">热力推荐</span>
      </div>
      <div class="live-box-content">
          <RefiningItem v-for="item of lives" :key="item.id" v-bind="item"/>
      </div>
    </div> -->
  </div>
</template>

<script>
// import Pdfh5 from 'pdfh5'
// import 'pdfh5/css/pdfh5.css'
// import pdf from 'vue-pdf'
// import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import 'swiper/js/swiper.js'
import Rotation from '../../components/Rotation.vue'
import HeatedDiscussion2 from '../../components/HeatedDiscussion2.vue'
// import RefiningItem from '../../components/RefiningItem'
import { safeHeight } from '../../utils/config'
import { get, post } from '../../utils/request'
import { get as getUser } from '../../utils/token'
import { isAndroid } from '../../utils/utils'
import { formateDateTostr } from '../../utils/date'
import { createNamespacedHelpers } from 'vuex'

import esgUrl from '../../assets/images/esg/circle_esg.png'
const { mapGetters, mapActions } = createNamespacedHelpers('tabbar')

export default {
  components: {
    Rotation,
    HeatedDiscussion2
    // RefiningItem
    // pdf
  },
  async activated () {
    // 热力推荐
    // this.getAllLiveList()
    // this.getSummonings()
    // this.getCalendarInfo()
    this.$refs.find.addEventListener('scroll', this.recordScrollPosition, true)
    this.$nextTick(() => {
      this.$refs.find.scrollTop = this.getBrowseCoordFindScroll
    })
  },
  created () {
    this.totoalFrom()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.updateTabIndex('find')
    })
  },
  data () {
    return {
      pdfh5: null,
      pdfShow: false,
      mobile: getUser('mobile'),
      voteList: [],
      height: window.innerWidth,
      lives: [],
      summonings: [],
      isAndroid: isAndroid(),
      safeHeight: safeHeight,
      modelSrc: '',
      downRefresh: false,
      downLabel: '',
      calendar: {
        count: 0,
        tag: 0,
        data: [],
        start_time: '',
        end_time: ''
      },
      user: getUser('user'),
      show: false,
      // pdfUrl1: 'https://exerlalnd.oss-cn-shanghai.aliyuncs.com/Euiadmin%E5%BC%80%E5%8F%91%E6%89%8B%E5%86%8C.pdf'
      // pdfUrl1: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf'
      // pdfUrl1: 'http://pdf.1234do.com/736808.pdf'
      pdfUrl1: '/static/736808.pdf',
      esgUrl: esgUrl,
      has_esg_entry: false // ESG 入口权限
    }
  },
  async mounted () {
    // this.loadPdf()
    /* eslint-disable no-new */
    // const { id } = this.user
    // 埋点
    this.$API.upUvData({
      user: this.getUserId,
      path: '/exerland/bbs/find',
      location: '首页',
      tracking_type: 1
    })
    this.getActivateVote()
    this.getPermission()
    if (this.HotTopicList.length === 0) {
      await this.$store.dispatch('TopicList/getTopicList', this.getUserId)
    }
    // 获取话题推荐列表，需要先完成数据的收集再去做轮播的处理，否者会产生无边界BUG
    new Swiper('.swiper-container', {
      pagination: '.swiper-pagination',
      slidesPerView: 'auto',
      paginationClickable: true,
      spaceBetween: 30,
      freeMode: true
    })
  },
  deactivated () {
    // 清除绑定的scroll事件
    this.$refs.find.removeEventListener('scroll', this.recordScrollPosition)
  },
  methods: {
    async getPermission () {
      try {
        const data = await this.$API.getESGpermission()
        if (data.code === 200) {
          this.has_esg_entry = data.data.has_esg_entry
        }
      } catch (error) {

      }
    },
    onRoute (info) {
      this.getESGTopicf()
      // 快速入口 跳转方法
      //   window.location.href = 'https://esg-ehome.fosun.com/esg-app'
      setTimeout(function () {
        // window.location.href = 'https://esg-ehome.fosun.com/esg-app/'
        window.location.href = 'https://new-ehome.fosun.com/ehome-app/esg/'
      }, 100)
    },
    async getESGTopicf () {
      await this.$API.getESGTopic()
      //   console.log(data)
    },
    goHuzhu () {
      window.location.href = 'https://moapp.fosun.com/hr/common/app/ihr2/#/assistancePlatform/home'
    },
    // 点击问卷通知栏触发
    goVoteDetail (id) {
      this.$router.push({ path: '/exerland/questionnaireDetail', query: { questionnaire_id: id } })
    },
    // 获取可填写状态投票列表
    async getActivateVote () {
      try {
        const data = await this.$API.getActivateVote(this.mobile)
        if (data.code === 200) {
          const arr = []
          data.data.list.forEach(item => {
            if (item.state === 'open') {
              arr.push(item)
            }
          })
          this.voteList = arr
        }
      } catch (error) {
        /* eslint-disable-next-line */
        console.log(error)
      }
    },
    recordScrollPosition (e) {
      this.$store.dispatch('BrowseCoord/updataBrowseCoordFindScroll', e.target.scrollTop)
    },
    goTopicDetails (tag) {
      // 跳转话题推荐详情的回调
      // 获取当前用户的相关信息
      // this.$API.upUvData({
      //   user: tag,
      //   path: '/#/index/',
      //   location: '首页'
      // })
      // 埋点
      this.$API.upUvData({
        user: this.getUserId,
        path: `/exerland/bbs/filterFind/${tag.id}/${tag.name}`,
        location: `首页-话题推荐-${tag.name}`,
        tracking_type: 2
      })
      const currentRoute = this.$router.currentRoute
      if (tag.type === 1) {
        if (currentRoute.name === 'FilterFind') {
          this.$router.replace({
            name: 'FilterFind',
            params: {
              id: tag.id,
              title: tag.name
            }
          })
        } else {
          this.$router.push({
            name: 'FilterFind',
            params: {
              id: tag.id,
              title: tag.name
            }
          })
        }
      } else {
        // 跳转召集令详情
        this.$router.push({
          path: '/exerland/officialCallingList'
        })
      }
    },
    totoalFrom () {
      const { id } = getUser('user')
      const { from } = this.$route.query
      const promise = post({
        url: '/user/enterCount',
        data: {
          source: from || '星圈',
          user: id,
          page: '/exerland/bbs/find'
        }
      })
      promise.then(res => {
        /* eslint-disable-next-line */
        console.log('totoalFrom', res)
      })
    },
    goSummoningOrderDetails (id) {
      this.$router.push({
        path: `/exerland/summoningOrderDetails/${id}`
      })
    },
    getStyle (index) {
      if (Object.is(index % 2, 1)) {
        return {
          background: 'rgba(0,150,136,1)'
        }
      }
      return {}
    },
    goSummongOrder () {
      this.$router.push('/exerland/bbs/dynamic?active=SummoningOrder')
    },
    goDynamic () {
      this.$router.push('/exerland/bbs/dynamic')
    },
    goDetails (id) {
      this.$router.push({
        path: `/exerland/summoningOrderDetails/${id}`
      })
    },
    goLaboratory () {
      this.$router.push({
        path: '/exerland/topic'
      })
    },
    goMakeComplaints () {
      this.$router.push({
        path: '/exerland/makeComplaints'
      })
    },
    goProposal () {
      // window.location.href = 'https://jinshuju.net/f/uy76Q9?x_field_1=focuth'
      window.location.href = 'https://contact.fosun.com/complaint/315'
    },
    goPartner () {
      window.location.href =
        'http://moapp.fosun.com/hr/common/app/ihr-toPartner/#/'
    },
    goCalendar () {
      this.$router.push({
        path: '/calendar'
      })
    },
    addDownRefresh () {
      const el = this.$refs.find
      el.addEventListener('touchstart', e => {
        if (this.downRefresh) {
          e.preventDefault()
          return
        }
        this.touchStart = e.targetTouches[0].clientY
      })
      el.addEventListener('touchmove', e => {
        if (this.downRefresh) {
          // e.preventDefault()
          return
        }
        if (el.scrollTop === 0) {
          const touch = e.targetTouches[0]
          const distance = touch.clientY - this.touchStart
          this.distance = distance
          if (distance > 50) {
            e.stopPropagation()
            this.downRefresh = true
            this.downLabel = '松手刷新数据'
          }
        }
      })
      el.addEventListener('touchend', e => {
        if (this.distance > 50) {
          this.downRefresh = true
          this.downLabel = '正在刷新'
          setTimeout(() => {
            this.downRefresh = false
            // this.getAllLiveList()
          }, 500)
        }
      })
    },
    ...mapActions({
      updateTabIndex: 'updateTabIndex'
    }),
    closeModelSrc () {
      this.modelSrc = ''
    },
    getCalendarInfo () {
      const promise = get({
        url: '/schedule/getRecentlySchedule'
        // baseURL: '10.170.108.28:8001/'
      })
      return promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          this.calendar = detail
        }
      })
    },
    getAllLiveList () {
      const promise = get({
        url: '/course/curriculumRecommendList'
      })
      return promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          this.lives = detail
        }
      })
    },
    getSummonings () {
      const user = getUser('user')
      const promise = get({
        url: `/call/hotTales/${user.id}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          this.summonings = detail
        }
      })
    },
    getTimeStr (regex = 'MM/DD 星期WEEK') {
      return formateDateTostr(new Date(), regex)
    },
    getTimeStr1 (time) {
      if (!time) {
        return
      }
      return time.substring(time.indexOf(' ') + 1)
    }
  },
  computed: {
    getUserId () { return this.user.id }, // 返回用户的ID
    ...mapGetters({
      getTabIndex: 'getTabIndex'
    }),
    getBrowseCoordFindScroll () {
      return this.$store.getters['BrowseCoord/getBrowseCoordFindScroll']
    },
    HotTopicList () {
      return this.$store.getters['TopicList/getAuth']
    },
    getCenterAuth () {
      return this.$store.getters['homeAuth/getAuth'] || {}
    },
    getCalendarInfos () {
      const { calendar } = this
      if (calendar.info) {
        return calendar
      }
      return this.calendar.count ? {
        ...this.calendar.data,
        info: ''
      } : {
        info: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  from {
    height: 0;
  }
  to {
    height: 50px;
  }
}
@keyframes scales {
  from {
    transform: scale(1, 1);
  }
  to {
    transform: scale(1.2, 1.2);
  }
}
.pdf {
  width: 100vw;
  height: 100vh;
}
.find {
  background: #fff;
  padding-bottom: 16px;
  width: 100%;
  box-sizing: border-box;
  height: calc(100% - 50px);
  overflow-y: scroll;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
  .recommend {
    margin: 10px auto;
    width: 92%;
    height: 160px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px #f2f2f2;
    box-shadow: 0 0 12px #e8e7e5;
    .recommend_dynamic_list::-webkit-scrollbar {
      width: 0;
    }
    .recommend_dynamic_list {
      display: flex;
      align-items: center;
      overflow-x: scroll;
      padding-left: 20px;
      padding-right: 20px;
      // width: 100%;
      height: 120px;
      .recommend_list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80px;
        flex-grow: 0; //是否自动增长空间
        flex-shrink: 0; //是否自动缩小空间
      }
      .recommend_list_detail {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 45px;
      }
      .recommend_list:not(:first-child) {
        margin-left: 10px;
      }
      .recommend_list:not(:last-child) {
        padding-right: 10px;
        border-right: 1px solid #888;
      }
      .recommend_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        height: 40px;
        // width: 230px;
        .goCreate {
          line-height: 25px;
          height: 25px;
          color: #fff;
          padding: 2px 4px;
          border-radius: 5px;
          background-color: #18cc9f;
          margin-left: 20px;
          text-align: center;
        }
        .CreateActive {
          background-color: rgb(255, 134, 16);
        }
        .recommend_dynamic_content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .recommend_dynamic_content_top {
            display: flex;
            font-weight: 700;
            align-items: center;
          }
          .recommend_dynamic_content_bottom {
            font-size: 12px;
          }
          img {
            width: 16px;
            vertical-align: bottom;
          }
        }
      }
    }
    .recommend_top {
      display: flex;
      align-items: center;
      height: 40px;
      background-color: #e1f4ee;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      img {
        height: 20px;
        margin-left: 10px;
      }
    }
  }
  .huzhu {
    width: 100%;
    text-align: center;
    img {
      width: 91.47%;
    }
  }
  .vote {
    display: flex;
    margin: 0 auto;
    width: 92%;
    height: 40px;
    .vote_icon {
      position: relative;
      width: 15%;
      height: 40px;
      background: #e9b312;
      border-radius: 12px 0 0 12px;
      img {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -10px;
        margin-left: -10px;
      }
    }
    .vote_content {
      width: 85%;
      display: flex;
      height: 40px;
      line-height: 40px;
      background: #fdf5dc;
      border-radius: 0 12px 12px 0;
      .vote_swipe {
        width: 85%;
        height: 40px;
        margin: auto;
        background: #fdf5dc;
        .vote_swipe_content {
          width: 600px;
          height: 40px;
          line-height: 40px;
          .btn {
            display: block;
            height: 40px;
            width: 100%;
            z-index: 999;
          }
        }
      }
      .vote_detail {
        display: flex;
        width: 15%;
        height: 16px;
        margin: auto;
        img {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
  .esg-wrap {
    margin: 10px auto;
    width: 92vw;
    // height: 40px;
    border-radius: 10px;
    /deep/ .van-image__img {
      border-radius: 10px;
    }
  }
  .topic {
    height: 160px;
    box-shadow: #f2f2f2 1px 1px 1px 1px; //边框阴影
    border-radius: 8px;
    .topic-Hot {
      display: flex;
      align-items: center;
      background-color: #e1f4ee;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      height: 41px;
      line-height: 41px;
      padding-left: 20px;
      font-size: 20px;
      font-weight: bold;
      img {
        width: 100px;
        height: 24px;
      }
    }
    .topic-advise {
      display: flex;
      align-items: center;
      // justify-content: flex-start;
      height: 120px;
      padding-left: 20px;
      position: relative;
      .topic-advise-default {
        margin: 0;
      }
      .topic-advise-list {
        border-right: 1px solid #888;
        margin-right: 20px !important;
        &:last-child {
          border: none;
          margin-right: 0px !important;
        }
        .topic-advise-value {
          // display: flex;
          // justify-content: space-between;
          margin-top: 5px;
          position: relative;
          width: 220px;
          // margin:5px 0;
          .topic-advise-test {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          .topic-advise-title {
            display: flex;
            align-items: center;
            font-weight: 700;
            font-size: 14px;
            img {
              width: 18px;
              height: 18px;
            }
          }
          .topic-advise-intro {
            display: inline-block;
            // height: 19px;
            // vertical-align: text-bottom;
            color: #888;
            font-size: 12px;
          }
          .topic-advise-btn {
            width: 46px;
            height: 23px;
            line-height: 23px;
            text-align: center;
            border-radius: 5px;
            color: #fff;
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            span {
              font-size: 14px;
            }
          }
        }
      }
      .swiper-slide {
        width: 230px !important;
      }
    }
  }
  .downLoading {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 50px;
    text-align: center;
    background: #fff;
  }
  h3 {
    text-align: center;
    padding-bottom: 9px;
    margin-bottom: 16px;
    font-size: 17px;
    font-family: SFProText-Semibold, SFProText;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
    border-bottom: 1px solid #e2e2e2;
  }
  .panel-box {
    margin: 0 auto;
    margin-top: 16px;
    width: 92.54vw;
    margin-bottom: 16px;
    .box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .calendar {
        width: calc(50% - 6px);
        height: 164px;
        background: #ffffff;
        box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        box-sizing: border-box;
        padding: 12px 15px;
        cursor: pointer;
        h2 {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #f3554f;
          line-height: 20px;
        }
        .day {
          height: 59px;
          font-size: 42px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 59px;
        }
        .info {
          position: relative;
          width: 100%;
          .point {
            position: absolute;
            width: 8px;
            height: 8px;
            background: #3165ec;
            border-radius: 50%;
            left: -10px;
            top: 6px;
          }
          span {
            font-size: 14px;
            color: #888888;
            line-height: 20px;
          }
          .title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
          }
          .titles {
            display: block;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .time {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #888888;
            line-height: 17px;
          }
        }
      }
    }
    .panel-box-header {
      width: 100vw !important;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      .query-all {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(136, 136, 136, 1);
        line-height: 20px;
        border: none;
        outline: none;
        background: #fff;
        margin-right: 16px;
      }
      .live-box-header-desc {
        height: 27px;
        font-size: 20px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        line-height: 27px;
        letter-spacing: 1px;
        margin-left: 16px;
      }
      .live-box-header-circle {
        box-sizing: border-box;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 2px solid #18cc9f;
        position: absolute;
        left: 92px;
        bottom: 5px;
      }
    }
    .summonings-box {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
      .summonings-item {
        width: 44.27vw;
        height: 104px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        box-sizing: border-box;
        padding: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h4 {
          width: 100%;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          text-overflow: ellipsis;
          img {
            width: 12px;
            height: 12px;
            display: inline-block;
            margin-right: 6px;
          }
        }
        .footer {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          span {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(136, 136, 136, 1);
            line-height: 17px;
          }
          .avater {
            width: 28px;
            height: 28px;
            border-radius: 50%;
          }
        }
      }
    }
    .live-box-content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      min-height: 178px;
      .gradients {
        background: linear-gradient(to right, #f4f4f4, #372e2e, #f4f4f4);
        width: 100%;
        height: 1px;
        &:first-child {
          margin-top: 20px;
        }
      }
      .summonings {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        margin-top: 16px;
        .summoning-item {
          width: 100%;
          padding: 15px 13px;
          display: flex;
          box-sizing: border-box;
          h3 {
            display: block;
            width: 100%;
          }
          span {
            display: inline-block;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 18px;
          }
          .name {
            color: #576b94;
            margin-right: 10px;
          }
        }
        button {
          width: 74px;
          height: 24px;
          background: rgba(0, 0, 0, 1);
          border-radius: 4px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 18px;
          border: none;
          outline: none;
        }
      }
    }
  }
  .true-words {
    margin-top: 12px;
    .panel-box-header {
      .live-box-header-circle {
        left: 70px;
      }
    }
    .live-box-content {
      // width: 164px;
      width: calc(50% - 6px);
      min-height: auto;
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      .true-words-item {
        position: relative;
        // width: 78px;
        // height: 78px;
        width: calc(50% - 5px);

        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        margin-bottom: 12px;
        .block {
          width: 100%;
          height: 100%;
        }
        .hot-discussion {
          position: absolute;
          top: -6px;
          right: -8px;
          width: 30px;
          height: 18px;
          z-index: 2;
          animation: scales 0.5s;
          animation-iteration-count: infinite;
          animation-direction: alternate;
          animation-timing-function: cubic-bezier(0, 0.4, 0.7, 1);
        }
        .open-soon {
          position: absolute;
          height: 52px;
          height: 52px;
        }
      }
    }
  }
  .hot {
    width: 100vw;
    .panel-box-header {
      width: 92.54vw;
      margin: 0 auto;
    }
    /deep/ .stick-item {
      padding: 0;
    }
  }
  .modelSrc {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9;
    background: rgba(0, 0, 0, 1);
    box-sizing: border-box;
    img {
      width: 100%;
      height: auto;
      border-radius: 10px;
      margin-top: 2vh;
    }
  }
}
</style>
